import { useContext } from 'react'
import UIContext from 'ui_context'

export function useHasGlobalAverageAllData() {
  const { sub } = useContext(UIContext)
  const subsWithGlobalAverageAllData =
    process.env?.REACT_APP_SUBS_WITH_GLOBAL_AVERAGE_ALL?.split(',') ?? []

  return subsWithGlobalAverageAllData.includes(sub)
}

export function useHasGlobalAverageLandcoverSubsetData() {
  const { sub } = useContext(UIContext)
  const subsWithGlobalAverageLandcoverSubsetData =
    process.env?.REACT_APP_SUBS_WITH_GLOBAL_AVERAGE_LANDCOVER_SUBSET?.split(
      ','
    ).map((subLccPair) => subLccPair.split(':')[0]) ?? []

  return subsWithGlobalAverageLandcoverSubsetData.includes(sub)
}

export function getLccForUser(sub: string) {
  const subLccData = Object.fromEntries(
    process.env?.REACT_APP_SUBS_WITH_GLOBAL_AVERAGE_LANDCOVER_SUBSET?.split(
      ','
    ).map((subLccPair) => subLccPair.split(':')) ?? []
  )

  return subLccData[sub]
}

export function useHasGlobalAveragePolygonSubsetData() {
  const { sub } = useContext(UIContext)
  const subsWithGlobalAveragePolygonSubsetData =
    process.env?.REACT_APP_SUBS_WITH_GLOBAL_AVERAGE_POLYGON_SUBSET?.split(
      ','
    ).map((entry) => entry.split(':')[0]) ?? []

  return subsWithGlobalAveragePolygonSubsetData.includes(sub)
}

export function getPolygonCountForUser(sub: string) {
  const subPolygonCountData = Object.fromEntries(
    process.env?.REACT_APP_SUBS_WITH_GLOBAL_AVERAGE_POLYGON_SUBSET?.split(
      ','
    ).map((entry) => {
      const [id, totalPolygonCount, polygonsWithGlobalAverageCount] =
        entry.split(':')
      return [id, { totalPolygonCount, polygonsWithGlobalAverageCount }]
    }) ?? []
  )

  return subPolygonCountData[sub]
}

export function useShowBanner() {
  const { userSub, sub } = useContext(UIContext)

  const isViewingDifferentSub = userSub !== sub
  const hasGlobalAverageAllData = useHasGlobalAverageAllData()
  const hasGlobalAverageLandcoverSubsetData =
    useHasGlobalAverageLandcoverSubsetData()
  const hasGlobalAveragePolygonSubsetData =
    useHasGlobalAveragePolygonSubsetData()

  return Boolean(
    isViewingDifferentSub ||
      hasGlobalAverageAllData ||
      hasGlobalAverageLandcoverSubsetData ||
      hasGlobalAveragePolygonSubsetData
  )
}
